export default __webpack_public_path__ + "static/media/sealofyog.e5c0fcd9.png";